const actions = {
  FETCH_PATIENTS_NEEDING_ATTENTION: 'AI_FETCH_PATIENTS_NEEDING_ATTENTION',
  FETCH_PATIENTS_NEEDING_ATTENTION_SUCCESS: 'AI_FETCH_PATIENTS_NEEDING_ATTENTION_SUCCESS',
  FETCH_PATIENTS_NEEDING_ATTENTION_ERROR: 'AI_FETCH_PATIENTS_NEEDING_ATTENTION_ERROR',
  ADD_PATIENT_NEEDING_ATTENTION: 'AI_ADD_PATIENT_NEEDING_ATTENTION',
  ADD_PATIENT_NEEDING_ATTENTION_SUCCESS: 'AI_ADD_PATIENT_NEEDING_ATTENTION_SUCCESS',
  ADD_PATIENT_NEEDING_ATTENTION_ERROR: 'AI_ADD_PATIENT_NEEDING_ATTENTION_ERROR',
  MARK_PATIENT_AS_ATTENDED: 'AI_MARK_PATIENT_AS_ATTENDED',
  MARK_PATIENT_AS_ATTENDED_SUCCESS: 'AI_MARK_PATIENT_AS_ATTENDED_SUCCESS',
  MARK_PATIENT_AS_ATTENDED_ERROR: 'AI_MARK_PATIENT_AS_ATTENDED_ERROR',
  REMOVE_PATIENT: 'AI_REMOVE_PATIENT',
  REMOVE_PATIENT_SUCCESS: 'AI_REMOVE_PATIENT_SUCCESS',
  REMOVE_PATIENT_ERROR: 'AI_REMOVE_PATIENT_ERROR',
  UPDATE_PATIENT_STATUS: 'AI_UPDATE_PATIENT_STATUS',
  UPDATE_PATIENT_STATUS_SUCCESS: 'AI_UPDATE_PATIENT_STATUS_SUCCESS',
  UPDATE_PATIENT_STATUS_ERROR: 'AI_UPDATE_PATIENT_STATUS_ERROR',
  UPDATE_WHATSAPP_MESSAGE: 'AI_UPDATE_WHATSAPP_MESSAGE',
  UPDATE_WHATSAPP_MESSAGE_SUCCESS: 'AI_UPDATE_WHATSAPP_MESSAGE_SUCCESS',
  UPDATE_WHATSAPP_MESSAGE_ERROR: 'AI_UPDATE_WHATSAPP_MESSAGE_ERROR',
  FETCH_WHATSAPP_MESSAGE: 'AI_FETCH_WHATSAPP_MESSAGE',
  FETCH_WHATSAPP_MESSAGE_SUCCESS: 'AI_FETCH_WHATSAPP_MESSAGE_SUCCESS',
  FETCH_WHATSAPP_MESSAGE_ERROR: 'AI_FETCH_WHATSAPP_MESSAGE_ERROR',
  GET_AI_PERMISSION: 'GET_AI_PERMISSION',
  GET_AI_PERMISSION_SUCCESS: 'AI_GET_AI_PERMISSION_SUCCESS',
  SET_LOADING: 'AI_SET_LOADING',
  SET_ERROR: 'AI_SET_ERROR',
  CLEAR_ERROR: 'AI_CLEAR_ERROR',
  RESET_PATIENTS_NEEDING_ATTENTION_LISTENER: 'RESET_PATIENTS_NEEDING_ATTENTION_LISTENER',
  FETCH_AI_DASHBOARD: 'AI_FETCH_DASHBOARD',
  FETCH_AI_DASHBOARD_SUCCESS: 'AI_FETCH_DASHBOARD_SUCCESS',
  FETCH_AI_DASHBOARD_ERROR: 'AI_FETCH_DASHBOARD_ERROR',
  // Painel da IA: totais de mensagens enviadas (contadores de uso da conta).
  fetchAiDashboard: () => ({
    type: actions.FETCH_AI_DASHBOARD,
  }),
  fetchPatientsNeedingAttention: () => ({
    type: actions.FETCH_PATIENTS_NEEDING_ATTENTION,
  }),
  fetchPatientsNeedingAttentionSuccess: (patients, totalWaitingWhatsApp) => ({
    type: actions.FETCH_PATIENTS_NEEDING_ATTENTION_SUCCESS,
    payload: {
      patients,
      totalWaitingWhatsApp,
    },
  }),
  fetchPatientsNeedingAttentionError: (error) => ({
    type: actions.FETCH_PATIENTS_NEEDING_ATTENTION_ERROR,
    payload: error,
  }),
  addPatientNeedingAttention: (patient) => ({
    type: actions.ADD_PATIENT_NEEDING_ATTENTION,
    payload: patient,
  }),
  addPatientNeedingAttentionSuccess: (patient) => ({
    type: actions.ADD_PATIENT_NEEDING_ATTENTION_SUCCESS,
    payload: patient,
  }),
  addPatientNeedingAttentionError: (error) => ({
    type: actions.ADD_PATIENT_NEEDING_ATTENTION_ERROR,
    payload: error,
  }),
  markPatientAsAttended: (patientId, status) => ({
    type: actions.MARK_PATIENT_AS_ATTENDED,
    payload: { patientId, status },
  }),
  markPatientAsAttendedSuccess: (payload) => ({
    type: actions.MARK_PATIENT_AS_ATTENDED_SUCCESS,
    payload,
  }),
  markPatientAsAttendedError: (error) => ({
    type: actions.MARK_PATIENT_AS_ATTENDED_ERROR,
    payload: error,
  }),
  removePatient: (patientId) => ({
    type: actions.REMOVE_PATIENT,
    payload: patientId,
  }),
  removePatientSuccess: (patientId) => ({
    type: actions.REMOVE_PATIENT_SUCCESS,
    payload: patientId,
  }),
  removePatientError: (error) => ({
    type: actions.REMOVE_PATIENT_ERROR,
    payload: error,
  }),
  updatePatientStatus: (patientId, status) => ({
    type: actions.UPDATE_PATIENT_STATUS,
    payload: { patientId, status },
  }),
  updatePatientStatusSuccess: (patientId, status) => ({
    type: actions.UPDATE_PATIENT_STATUS_SUCCESS,
    payload: { patientId, status },
  }),
  updatePatientStatusError: (error) => ({
    type: actions.UPDATE_PATIENT_STATUS_ERROR,
    payload: error,
  }),
  setLoading: (loading) => ({
    type: actions.SET_LOADING,
    payload: loading,
  }),
  setError: (error) => ({
    type: actions.SET_ERROR,
    payload: error,
  }),
  clearError: () => ({
    type: actions.CLEAR_ERROR,
  }),
  updateWhatsAppMessage: (message) => ({
    type: actions.UPDATE_WHATSAPP_MESSAGE,
    payload: message,
  }),
  updateWhatsAppMessageSuccess: (message) => ({
    type: actions.UPDATE_WHATSAPP_MESSAGE_SUCCESS,
    payload: message,
  }),
  updateWhatsAppMessageError: (error) => ({
    type: actions.UPDATE_WHATSAPP_MESSAGE_ERROR,
    payload: error,
  }),
  fetchWhatsAppMessage: () => ({
    type: actions.FETCH_WHATSAPP_MESSAGE,
  }),
  fetchWhatsAppMessageSuccess: (message) => ({
    type: actions.FETCH_WHATSAPP_MESSAGE_SUCCESS,
    payload: message,
  }),
  fetchWhatsAppMessageError: (error) => ({
    type: actions.FETCH_WHATSAPP_MESSAGE_ERROR,
    payload: error,
  }),
  getAiPermissionSuccess: (permissions) => ({
    type: actions.GET_AI_PERMISSION_SUCCESS,
    payload: {
      permissions,
    },
  }),
};

export default actions;
